<template>
  <a-button
    @click="(e) => $emit('click', e)"
    class="btn twitter-btn"
    icon="twitter"
    :disabled="disabled"
    >Twitter</a-button
  >
</template>

<script>
export default {
  props: ['disabled'],
};
</script>

<style lang="scss">
@import '~@/assets/styles/colors';

.twitter-btn {
  color: #00b0f3;
  border-color: #00b0f3;
}

.twitter-btn i svg {
  height: 16px;
  width: 16px;
  margin-top: 2px;
}
</style>
